import { RawVideoSource } from '../types';
import hash from 'object-hash';

export const getPlaylistHash = (playlist: Array<RawVideoSource>): string => {
  return hash(playlist);
};
